import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'
import { Stack, Typography } from '@mui/material'

interface RevenueGraphProps {
  data?: Array<{ month: string; revenue: number }>
}

const RevenueGraph = ({ data }: RevenueGraphProps) => {
  if (!data || data.length === 0) {
    return (
      <Stack justifyContent="center" alignItems="center" sx={{ height: '400px', color: '#999' }}>
        <Typography variant="h6">No data available</Typography>
      </Stack>
    )
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="month" stroke="#666" />
        <YAxis
          stroke="#666"
          tickFormatter={(value) =>
            `€${value.toLocaleString('de-DE', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })}`
          }
        />
        <Tooltip
          formatter={(value: number) =>
            `€${value.toLocaleString('de-DE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          }
          contentStyle={{
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '10px',
          }}
        />
        <Line
          type="monotone"
          dataKey="revenue"
          stroke="#5E35B1"
          strokeWidth={3}
          dot={{ fill: '#5E35B1', r: 4 }}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  )
}

export default RevenueGraph
